module.exports = __webpack_public_path__ + "img/jbt3411_64-1999.prt.42098a69.jpg";